<script lang="ts">
import { siInstagram } from "simple-icons";
import SimpleIcon from "./SimpleIcon.svelte";

let { class: className }: { class?: string } = $props();
</script>

<SimpleIcon icon={siInstagram} class={className} />
